import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=20b4626a&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=20b4626a&prod&lang=scss"
import style1 from "./DocumentPreview.vue?vue&type=style&index=1&id=20b4626a&prod&lang=scss&scoped=true"
import style2 from "./DocumentPreview.vue?vue&type=style&index=2&id=20b4626a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4626a",
  null
  
)

export default component.exports